"use client";

import { useAppContext } from "@/context/AppContext";
import { useEffect } from "react";

/**
 * Dynamically updates window.chsn_pageType based on localization state.
 * Must be rendered inside AppProvider to access isLocalized state.
 * Updates pageType from "notLocalized" to "localized" when session is detected.
 *
 * Hydration-safe: useEffect only runs client-side after mount.
 */
export default function DynamicPageType() {
  const { isLocalized } = useAppContext();

  useEffect(() => {
    const newPageType = isLocalized ? "localized" : "notLocalized";
    window.chsn_pageType = newPageType;
  }, [isLocalized]);

  return null;
}
